export const bannerImages = {
  viewType: 'CAROUSEL',
  items: [
    {
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1687848168469-dweb_CD_top_banners_01.webp',
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1687848312640-mweb_CD_top_banners_01.webp',
      itemSize: 'LARGE',
    },
    {
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1687848168473-dweb_CD_top_banners_02.webp',
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1687848312641-mweb_CD_top_banners_02.webp',
      itemSize: 'LARGE',
    },
    {
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1687848168474-dweb_CD_top_banners_03.webp',
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1687848312641-mweb_CD_top_banners_03.webp',
      itemSize: 'LARGE',
    },
    {
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1687848168475-dweb_CD_top_banners_04.webp',
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1687848312641-mweb_CD_top_banners_04.webp',
      itemSize: 'LARGE',
    },
    {
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1687848168476-dweb_CD_top_banners_05.webp',
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1687848312642-mweb_CD_top_banners_05.webp',
      itemSize: 'LARGE',
    },
    {
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1687848478410-dweb_CD_top_banners_06.webp',
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1687848436098-mweb_CD_top_banners_06.webp',
      itemSize: 'LARGE',
    },
    {
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1687848478411-dweb_CD_top_banners_07.webp',
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1687848436099-mweb_CD_top_banners_07.webp',
      itemSize: 'LARGE',
    },
  ],
};
export const cdlistingnewversion = {
  items: [
    {
      _id: '',
      itemType: 'MULTIPLE_ITEMS',
      itemName: 'info_assest_cloth_diaper_page_templet',
      deeplink: null,
      deeplinkValue: null,
      heading: '5 Reasons to Choose Mylo Cloth Diapers',
      headingAlignment: 'WAVECAROUSEL',
      headingRightIcon: '',
      viewType: 'HORIZONTAL',
      gridSize: 2,
      items: [
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1698137604435-CD-down-carousel_01.webp',
          heading: 'OEKO-TEX® CERTIFIED DIAPERS',
          subHeading:
            'Mylo Baby Cloth Diapers are India’s First Oeko-Tex® Certified Cloth Diapers, ensuring your baby’s bum doesn’tcome in contact with any harmful chemicals.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1698137604438-CD-down-carousel_02.webp',

          heading: 'ZERO LEAKS',
          subHeading:
            'With its 6 Layered Insert Pads and SmartCuff TechnologyTM that creates a lock between legs and pelvic area, our Cloth Diapers remain dry for up to 5 hours.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1698137604438-CD-down-carousel_03.webp',

          heading: 'GOODNESS OF CLOTH',
          subHeading:
            'With the gentleness of cotton, your baby’s delicate bums get more room to breathe and remain rash-free and oh-so-happy.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1698137604438-CD-down-carousel_04.webp',

          heading: '100% PERFECT FIT',
          subHeading:
            'The Snap Buttons can be adjusted according to baby’s height and weight, offering a perfect snug fit to babies from 3 months to 3 years.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1698137604439-CD-down-carousel_05.webp',
          heading: 'DOCTOR RECOMMENDED',
          subHeading: 'Doctors recommend Cloth Diapering for rash-free bums.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
      ],
      priority: 3,
      sectionBgImage: '',
      sectionBgImageHi: '',
      sectionBgColorStart: '#ffffff',
      sectionBgColorEnd: '#ffffff',
      objectId: 0,
      contentType: '',
      itemSize: 'SMALL',
      expertCardViewType: 'PRICE_HIGHLIGHTED',
      categoryTagIds: [],
      videoUrlData: {
        isAutoPlay: false,
        mute: false,
        playerType: 'youtube',
        videoUrl: '',
        thumbnailImage: '',
      },
      viewAllCtaDeeplinkValue: null,
      showViewAllCard: false,
      viewAllDeeplink: null,
      viewAllDeeplinkValue: null,
      viewAllBannerImage: null,
      viewAllBannerImageHi: null,
      offerIds: [],
      tagIds: [],
      tagId: null,
      geoCheck: false,
      articleLimit: 10,
      articleTags: [],
      dietChartItem: false,
      extra: {
        utilityData: null,
      },
      clinicServiceType: [],
      htmlText: '',
      createdAt: '2022-09-06T12:38:05.065Z',
      updatedAt: '2022-11-17T09:58:56.809Z',
      __v: 0,
      generalItemBgImage: '',
      generalItemBgImageHi: '',
      headingHi: '',
      subHeading: '',
      subHeadingHi: '',
      ctaText: 'SELECT YOUR DIAPER ',
      spinEligible: [2],
      formPoints: [],
      timerOfferIds: [],
      dsLabel: '',
      isGeneralItem: true,
    },
    {
      _id: '3032',
      itemType: 'MULTIPLE_ITEMS',
      itemName: 'select CTA_4',
      deeplink: null,
      deeplinkValue: null,
      headingAlignment: 'TOP',
      headingRightIcon: '',
      cardView: true,
      showCta: false,
      getFromCache: true,
      ctaText: 'SELECT YOUR FAVORITE DIAPERS ',
      viewType: 'HORIZONTAL',
      gridSize: null,
      items: [
        {
          mobileWebImage:
            'https://images.myloapp.in/mydo_upload/166816359697.png',
          desktopImage:
            'https://images.myloapp.in/mydo_upload/166816359652.png',
          heading: '',
          subHeading: '',
          deeplinkValue: '/category/safest-cloth-diapers',
          ctaText: '',
          showCta: false,
          itemType: 'CustomBanner',
        },
      ],
      priority: 7,
      sectionBgImage: '',
      sectionBgImageHi: '',
      sectionBgColorStart: '#ffffff',
      sectionBgColorEnd: '#ffffff',
      objectId: 0,
      contentType: '',
      itemSize: 'SMALL',
      expertCardViewType: 'PRICE_HIGHLIGHTED',
      categoryTagIds: [],
      videoUrlData: {
        isAutoPlay: false,
        mute: false,
        playerType: 'youtube',
        videoUrl: '',
        thumbnailImage: '',
      },
      viewAllCtaDeeplinkValue: null,
      showViewAllCard: false,
      viewAllDeeplink: null,
      viewAllDeeplinkValue: null,
      viewAllBannerImage: null,
      viewAllBannerImageHi: null,
      offerIds: [],
      timerOfferIds: [],
      tagIds: [],
      tagId: null,
      geoCheck: false,
      articleLimit: 10,
      articleTags: [],
      dietChartItem: false,
      feedingOptions: [],
      contentIds: [],
      tagBadgeData: null,
      extra: {
        utilityData: null,
      },
      clinicServiceType: [],
      htmlText: '',
      timeLimit: false,
      startTime: null,
      endTime: null,
      tagWebUrl: null,
      spinEligible: [2],
      formPoints: [],
      dsLabel: '',
      createdAt: '2022-11-11T10:56:56.844Z',
      updatedAt: '2022-11-24T15:46:46.638Z',
      __v: 0,
      generalItemBgImage: '',
      generalItemBgImageHi: '',
      heading: '',
      headingHi: '',
      subHeading: '',
      subHeadingHi: '',
      isGeneralItem: true,
    },
    {
      _id: '3123',
      itemType: 'MULTIPLE_ITEMS',
      itemName: 'happiness',
      deeplink: null,
      deeplinkValue: null,
      heading: 'LOVED BY 10 MILLION + MOMS ',
      headingAlignment: 'WAVE',
      headingRightIcon: '',
      cardView: true,
      showCta: false,
      getFromCache: true,
      ctaText: 'SELECT YOUR DIAPER ',
      viewType: 'HORIZONTAL',
      gridSize: null,
      items: [
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607394-Shreya-Arora.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CjunBqXpwHt/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'shreyaa.siddhartharora',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678421300927-shreyaa.webp',
          instaFollower: '119k Followers',
          heading: '',
          subHeading:
            'I prefer Mylo Cloth Diapers for Sidya. She plays comfortably in them and the abosorption is also good, what else do I want :)',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226853647-Sweety-Yadav.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CikNH_GBZff/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'flying_mom_23',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678441592461-flyingmom.webp',
          instaFollower: '48.3k Followers',
          heading: '',
          subHeading:
            'Recently I have came across Mylo cloth diapers and I am so loving it for Shanaya.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607393-IshitA-Kotak.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/Cjzq0GUInSw/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'ishita_kotak_',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701401-ishitakotak.webp',
          instaFollower: '1713 Followers',
          heading: '',
          subHeading:
            'The best thing I have chosen for my baby Arhaan and noticed that my baby has little to no diaper rashes since we switched to Mylo Cloth Diapers. ',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607393-Shalini-Priya.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CizXiXZDCTV/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'shalinipriyaofficial',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701396-shalinipriya.webp',
          instaFollower: '121k Followers',
          heading: '',
          subHeading:
            'Viraj feels super comfy and happy. Diapering ka aisa smart tareeka that saves my money in the long run.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607393-Priyanka-Singhal.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CisR2-NBNDB/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'mumzcub',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701407-mumzcub.webp',
          instaFollower: '77.7k Followers',
          heading: '',
          subHeading:
            "I love the cute prints and designs available in cloth diapers. They're so much more fun than plain white disposables.",
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607391-Dimple-Kumar.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/p/Cj42rZtujw3/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'dilli_wali_mummi',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701406-dillivalimummy.webp',
          instaFollower: '13k Followers',
          heading: '',
          subHeading:
            "I feel good knowing that I'm doing my part to reduce waste and pollution by using cloth diapers. The comfort of these diapers makes my baby happy. ",
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
      ],
      priority: 8,
      sectionBgImage: '',
      sectionBgImageHi: '',
      sectionBgColorStart: '#ffffff',
      sectionBgColorEnd: '#ffffff',
      objectId: 0,
      contentType: '',
      itemSize: 'SMALL',
      expertCardViewType: 'PRICE_HIGHLIGHTED',
      categoryTagIds: [],
      videoUrlData: {
        isAutoPlay: false,
        mute: false,
        playerType: 'youtube',
        videoUrl: '',
        thumbnailImage: '',
      },
      viewAllCtaDeeplinkValue: null,
      showViewAllCard: false,
      viewAllDeeplink: null,
      viewAllDeeplinkValue: null,
      viewAllBannerImage: null,
      viewAllBannerImageHi: null,
      offerIds: [],
      timerOfferIds: [],
      tagIds: [],
      tagId: null,
      geoCheck: false,
      articleLimit: 10,
      articleTags: [],
      dietChartItem: false,
      feedingOptions: [],
      contentIds: [],
      tagBadgeData: null,
      extra: {
        utilityData: null,
      },
      clinicServiceType: [],
      htmlText: '',
      timeLimit: false,
      startTime: null,
      endTime: null,
      tagWebUrl: null,
      spinEligible: [2],
      formPoints: [],
      dsLabel: '',
      gradientList: [],
      createdAt: '2022-11-24T14:06:43.525Z',
      updatedAt: '2023-01-20T05:26:32.721Z',
      __v: 0,
      generalItemBgImage: '',
      generalItemBgImageHi: '',
      headingHi: '',
      subHeading: '',
      subHeadingHi: '',
      isHorizontalScrollable: true,
      promotionalProgramId: '',
      isGeneralItem: true,
    },
    {
      _id: '',
      itemType: 'MULTIPLE_ITEMS',
      itemName: 'How Mylo compares',
      deeplink: null,
      deeplinkValue: null,
      heading: '',
      headingAlignment: 'TOP',
      headingRightIcon: '',
      cardView: true,
      showCta: false,
      getFromCache: true,
      viewType: 'HORIZONTAL',
      gridSize: null,
      desktopGridSize: null,
      items: [
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1679028007879-myloothersidemobile.webp',
          desktopImage:
            'https://images.myloapp.in/NestJsUploads/1679028007877-myloothersidedesktop.webp',
          heading: '',
          subHeading: '',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
      ],
      priority: 4,
      sectionBgImage: '',
      sectionBgImageHi: '',
      sectionBgColorStart: '#ffffff',
      sectionBgColorEnd: '#ffffff',
      objectId: 0,
      contentType: '',
      itemSize: 'LARGE',
      expertCardViewType: 'PRICE_HIGHLIGHTED',
      categoryTagIds: [],
      videoUrlData: {
        isAutoPlay: false,
        mute: false,
        playerType: 'youtube',
        videoUrl: '',
        thumbnailImage: '',
      },
      viewAllCtaDeeplinkValue: null,
      showViewAllCard: false,
      viewAllDeeplink: null,
      viewAllDeeplinkValue: null,
      viewAllBannerImage: null,
      viewAllBannerImageHi: null,
      offerIds: [],
      timerOfferIds: [],
      tagIds: [],
      tagId: null,
      geoCheck: false,
      articleLimit: 10,
      articleTags: [],
      dietChartItem: false,
      feedingOptions: [],
      contentIds: [],
      tagBadgeData: null,
      extra: {
        utilityData: null,
      },
      clinicServiceType: [],
      htmlText: '',
      timeLimit: false,
      startTime: null,
      endTime: null,
      tagWebUrl: null,
      spinEligible: [2],
      formPoints: [],
      dsLabel: '',
      gradientList: [],
      isHorizontalScrollable: false,
      promotionalProgramId: '',
      createdAt: '2023-01-14T16:11:40.217Z',
      updatedAt: '2023-01-16T06:48:18.292Z',
      __v: 0,
      generalItemBgImage: '',
      generalItemBgImageHi: '',
      headingHi: '',
      subHeading: '',
      subHeadingHi: '',
      isGeneralItem: true,
    },
  ],
};

export const newcdlistingnewversion = {
  items: [
    {
      _id: '3032',
      itemType: 'MULTIPLE_ITEMS',
      itemName: 'select CTA_4',
      deeplink: null,
      deeplinkValue: null,
      headingAlignment: 'TOP',
      headingRightIcon: '',
      cardView: true,
      showCta: false,
      getFromCache: true,
      ctaText: 'SELECT YOUR FAVORITE DIAPERS ',
      viewType: 'HORIZONTAL',
      gridSize: null,
      items: [
        {
          mobileWebImage:
            'https://images.myloapp.in/mydo_upload/166816359697.png',
          desktopImage:
            'https://images.myloapp.in/mydo_upload/166816359652.png',
          heading: '',
          subHeading: '',
          deeplinkValue: '/category/safest-cloth-diapers',
          ctaText: '',
          showCta: false,
          itemType: 'CustomBanner',
        },
      ],
      priority: 7,
      sectionBgImage: '',
      sectionBgImageHi: '',
      sectionBgColorStart: '#ffffff',
      sectionBgColorEnd: '#ffffff',
      objectId: 0,
      contentType: '',
      itemSize: 'SMALL',
      expertCardViewType: 'PRICE_HIGHLIGHTED',
      categoryTagIds: [],
      videoUrlData: {
        isAutoPlay: false,
        mute: false,
        playerType: 'youtube',
        videoUrl: '',
        thumbnailImage: '',
      },
      viewAllCtaDeeplinkValue: null,
      showViewAllCard: false,
      viewAllDeeplink: null,
      viewAllDeeplinkValue: null,
      viewAllBannerImage: null,
      viewAllBannerImageHi: null,
      offerIds: [],
      timerOfferIds: [],
      tagIds: [],
      tagId: null,
      geoCheck: false,
      articleLimit: 10,
      articleTags: [],
      dietChartItem: false,
      feedingOptions: [],
      contentIds: [],
      tagBadgeData: null,
      extra: {
        utilityData: null,
      },
      clinicServiceType: [],
      htmlText: '',
      timeLimit: false,
      startTime: null,
      endTime: null,
      tagWebUrl: null,
      spinEligible: [2],
      formPoints: [],
      dsLabel: '',
      createdAt: '2022-11-11T10:56:56.844Z',
      updatedAt: '2022-11-24T15:46:46.638Z',
      __v: 0,
      generalItemBgImage: '',
      generalItemBgImageHi: '',
      heading: '',
      headingHi: '',
      subHeading: '',
      subHeadingHi: '',
      isGeneralItem: true,
    },
    {
      _id: '3123',
      itemType: 'MULTIPLE_ITEMS',
      itemName: 'happiness',
      deeplink: null,
      deeplinkValue: null,
      heading: 'LOVED BY 10 MILLION + MOMS ',
      headingAlignment: 'WAVE',
      headingRightIcon: '',
      cardView: true,
      showCta: false,
      getFromCache: true,
      ctaText: 'SELECT YOUR DIAPER ',
      viewType: 'HORIZONTAL',
      gridSize: null,
      items: [
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607394-Shreya-Arora.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CjunBqXpwHt/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'shreyaa.siddhartharora',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678421300927-shreyaa.webp',
          instaFollower: '119k Followers',
          heading: '',
          subHeading:
            'I prefer Mylo Cloth Diapers for Sidya. She plays comfortably in them and the abosorption is also good, what else do I want :)',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226853647-Sweety-Yadav.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CikNH_GBZff/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'flying_mom_23',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678441592461-flyingmom.webp',
          instaFollower: '48.3k Followers',
          heading: '',
          subHeading:
            'Recently I have came across Mylo cloth diapers and I am so loving it for Shanaya.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607393-IshitA-Kotak.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/Cjzq0GUInSw/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'ishita_kotak_',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701401-ishitakotak.webp',
          instaFollower: '1713 Followers',
          heading: '',
          subHeading:
            'The best thing I have chosen for my baby Arhaan and noticed that my baby has little to no diaper rashes since we switched to Mylo Cloth Diapers. ',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607393-Shalini-Priya.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CizXiXZDCTV/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'shalinipriyaofficial',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701396-shalinipriya.webp',
          instaFollower: '121k Followers',
          heading: '',
          subHeading:
            'Viraj feels super comfy and happy. Diapering ka aisa smart tareeka that saves my money in the long run.',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607393-Priyanka-Singhal.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/reel/CisR2-NBNDB/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'mumzcub',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701407-mumzcub.webp',
          instaFollower: '77.7k Followers',
          heading: '',
          subHeading:
            "I love the cute prints and designs available in cloth diapers. They're so much more fun than plain white disposables.",
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1675226607391-Dimple-Kumar.webp',
          desktopImage: '',
          instaVideo:
            'https://www.instagram.com/p/Cj42rZtujw3/?utm_source=ig_embed&utm_campaign=loading',
          instaName: 'dilli_wali_mummi',
          instaImage:
            'https://images.myloapp.in/NestJsUploads/1678442701406-dillivalimummy.webp',
          instaFollower: '13k Followers',
          heading: '',
          subHeading:
            "I feel good knowing that I'm doing my part to reduce waste and pollution by using cloth diapers. The comfort of these diapers makes my baby happy. ",
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
      ],
      priority: 8,
      sectionBgImage: '',
      sectionBgImageHi: '',
      sectionBgColorStart: '#ffffff',
      sectionBgColorEnd: '#ffffff',
      objectId: 0,
      contentType: '',
      itemSize: 'SMALL',
      expertCardViewType: 'PRICE_HIGHLIGHTED',
      categoryTagIds: [],
      videoUrlData: {
        isAutoPlay: false,
        mute: false,
        playerType: 'youtube',
        videoUrl: '',
        thumbnailImage: '',
      },
      viewAllCtaDeeplinkValue: null,
      showViewAllCard: false,
      viewAllDeeplink: null,
      viewAllDeeplinkValue: null,
      viewAllBannerImage: null,
      viewAllBannerImageHi: null,
      offerIds: [],
      timerOfferIds: [],
      tagIds: [],
      tagId: null,
      geoCheck: false,
      articleLimit: 10,
      articleTags: [],
      dietChartItem: false,
      feedingOptions: [],
      contentIds: [],
      tagBadgeData: null,
      extra: {
        utilityData: null,
      },
      clinicServiceType: [],
      htmlText: '',
      timeLimit: false,
      startTime: null,
      endTime: null,
      tagWebUrl: null,
      spinEligible: [2],
      formPoints: [],
      dsLabel: '',
      gradientList: [],
      createdAt: '2022-11-24T14:06:43.525Z',
      updatedAt: '2023-01-20T05:26:32.721Z',
      __v: 0,
      generalItemBgImage: '',
      generalItemBgImageHi: '',
      headingHi: '',
      subHeading: '',
      subHeadingHi: '',
      isHorizontalScrollable: true,
      promotionalProgramId: '',
      isGeneralItem: true,
    },
    {
      _id: '',
      itemType: 'MULTIPLE_ITEMS',
      itemName: 'How Mylo compares',
      deeplink: null,
      deeplinkValue: null,
      heading: '',
      headingAlignment: 'TOP',
      headingRightIcon: '',
      cardView: true,
      showCta: false,
      getFromCache: true,
      viewType: 'HORIZONTAL',
      gridSize: null,
      desktopGridSize: null,
      items: [
        {
          mobileWebImage:
            'https://images.myloapp.in/NestJsUploads/1753953809949-Group-1244835612.webp',
          desktopImage:
            'https://images.myloapp.in/NestJsUploads/1679028007877-myloothersidedesktop.webp',
          heading: '',
          subHeading: '',
          deeplinkValue: '',
          ctaText: '',
          showCta: false,
          itemType: 'BANNER',
        },
      ],
      priority: 4,
      sectionBgImage: '',
      sectionBgImageHi: '',
      sectionBgColorStart: '#ffffff',
      sectionBgColorEnd: '#ffffff',
      objectId: 0,
      contentType: '',
      itemSize: 'LARGE',
      expertCardViewType: 'PRICE_HIGHLIGHTED',
      categoryTagIds: [],
      videoUrlData: {
        isAutoPlay: false,
        mute: false,
        playerType: 'youtube',
        videoUrl: '',
        thumbnailImage: '',
      },
      viewAllCtaDeeplinkValue: null,
      showViewAllCard: false,
      viewAllDeeplink: null,
      viewAllDeeplinkValue: null,
      viewAllBannerImage: null,
      viewAllBannerImageHi: null,
      offerIds: [],
      timerOfferIds: [],
      tagIds: [],
      tagId: null,
      geoCheck: false,
      articleLimit: 10,
      articleTags: [],
      dietChartItem: false,
      feedingOptions: [],
      contentIds: [],
      tagBadgeData: null,
      extra: {
        utilityData: null,
      },
      clinicServiceType: [],
      htmlText: '',
      timeLimit: false,
      startTime: null,
      endTime: null,
      tagWebUrl: null,
      spinEligible: [2],
      formPoints: [],
      dsLabel: '',
      gradientList: [],
      isHorizontalScrollable: false,
      promotionalProgramId: '',
      createdAt: '2023-01-14T16:11:40.217Z',
      updatedAt: '2023-01-16T06:48:18.292Z',
      __v: 0,
      generalItemBgImage: '',
      generalItemBgImageHi: '',
      headingHi: '',
      subHeading: '',
      subHeadingHi: '',
      isGeneralItem: true,
    },
  ],
};

export const newExperimentProducts = [
  {
    id: 3271,
    image:
      'https://images.myloapp.in/gullack_products/product_1681291405_196530927.webp',
    price: 599,
    variantType: 'Color Maze',
    strikeprice: 899,
    base_discount: 5,
    addToCart: true,
    quantity: 0,
    name: 'Mylo Adjustable Washable & Reusable Top lay Cloth Diaper with SmartCuff Technology for Enhanced Leak Protection-Comes with 1 Dry Feel Absorbent Insert Pad (3M-3Y)- Color Maze',
    discount: '34% Off',
  },
  {
    id: 3272,
    image:
      'https://images.myloapp.in/gullack_products/product_1681294864_1323627481.webp',
    price: 599,
    variantType: 'Pastel Blocks',
    strikeprice: 899,
    base_discount: 5,
    addToCart: true,
    quantity: 0,
    name: 'Mylo Adjustable Washable & Reusable Top lay Cloth Diaper with SmartCuff Technology for Enhanced Leak Protection-Comes with 1 Dry Feel Absorbent Insert Pad (3M-3Y)- Pastel Blocks',
    discount: '34% Off',
  },
  {
    id: 3273,
    image:
      'https://images.myloapp.in/gullack_products/product_1681298411_2050375183.webp',
    price: 599,
    variantType: 'Chevron Wave',
    strikeprice: 899,
    base_discount: 5,
    addToCart: true,
    quantity: 0,
    discount: '34% Off',
    name: 'Mylo Adjustable Washable & Reusable Top lay Cloth Diaper with SmartCuff Technology for Enhanced Leak Protection-Comes with 1 Dry Feel Absorbent Insert Pad (3M-3Y)- Chevron Wave',
  },
  {
    id: 3274,
    image:
      'https://images.myloapp.in/gullack_products/product_1681299362_1843901066.webp',
    price: 599,
    variantType: 'Aqua Fun',
    strikeprice: 899,
    base_discount: 5,
    addToCart: true,
    quantity: 0,
    discount: '34% Off',
    name: 'Mylo Adjustable Washable & Reusable Top lay Cloth Diaper with SmartCuff Technology for Enhanced Leak Protection-Comes with 1 Dry Feel Absorbent Insert Pad (3M-3Y)- Aqua Fun',
  },
  {
    id: 3275,
    image:
      'https://images.myloapp.in/gullack_products/product_1681293973_95101525.webp',
    price: 599,
    variantType: 'Adorable Pirates',
    strikeprice: 899,
    base_discount: 5,
    addToCart: true,
    quantity: 0,
    discount: '34% Off',
    name: 'Mylo Adjustable Washable & Reusable Top lay Cloth Diaper with SmartCuff Technology for Enhanced Leak Protection-Comes with 1 Dry Feel Absorbent Insert Pad (3M-3Y)- Cute Pals',
  },
  {
    id: 3276,
    image:
      'https://images.myloapp.in/gullack_products/product_1681295939_1321959671.webp',
    price: 599,
    variantType: 'Zesty Orange',
    strikeprice: 899,
    base_discount: 5,
    addToCart: false,
    quantity: 1,
    discount: '34% Off',
    name: 'Mylo Adjustable Washable & Reusable Top lay Cloth Diaper with SmartCuff Technology for Enhanced Leak Protection-Comes with 1 Dry Feel Absorbent Insert Pad (3M-3Y)- Zesty Orange',
  },
  {
    id: 3277,
    image:
      'https://images.myloapp.in/gullack_products/product_1681297538_393788598.webp',
    price: 599,
    variantType: 'Cute Pals',
    strikeprice: 899,
    base_discount: 5,
    addToCart: true,
    quantity: 0,
    discount: '34% Off',
    name: 'Mylo Adjustable Washable & Reusable Top lay Cloth Diaper with SmartCuff Technology for Enhanced Leak Protection-Comes with 1 Dry Feel Absorbent Insert Pad (3M-3Y)- Cute Pals',
  },
];
export const hardcodedIds = '3271,3272,3273,3274,3275,3276,3277';

export const changeToArraywithShuffling = (productData) => {
  const idSplit = productData?.split(',');
  const idArray = [];
  idSplit.map((element) => idArray.push(element));
  return getShuffledData(idArray);
};

export const getShuffledData = (productData, oldData) => {
  const shuffledProducts = (data) => {
    for (let i = data.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [data[i], data[j]] = [data[j], data[i]];
    }
    return data || [];
  };
  const fixedPrintItems = productData.slice(0, 3);
  const randomProductsByPrint = shuffledProducts(productData.slice(3));
  const totalPrintItems = showOtherHardcodedSkus()
    ? fixedPrintItems.concat(randomProductsByPrint)
    : oldData;
  return totalPrintItems;
};

export const showOtherHardcodedSkus = () => {
  // return getWebUserType() === "B";
  return false;
};
export const updateVariantType = (offerCartData) => {
  offerCartData?.productList?.map((element, index) => {
    newExperimentProducts?.map((data) => {
      if (data?.id === element?.id) {
        element.variantType = data?.variantType;
      }
    });
  });
};
